// Mappatura dei suffissi URL alle regioni (US, CA, EMEA)
window.PERSOL_ROOT_URL_MAPPINGS = {
  // US suffixes (en-us and es-us share the same register/marketing logic)
  "/en-us": "US",
  "/es-us": "US",

  // CA suffixes
  "/en-ca": "CA",
  "/fr-ca": "CA",
  
  // EMEA suffixes
  "/en-gb": "EMEA", // Regno Unito
  "/en-de": "EMEA", // Germania (inglese)
  "/de-de": "EMEA", // Germania (tedesco)
  "/en-fr": "EMEA", // Francia (inglese)
  "/fr-fr": "EMEA", // Francia (francese)
  "/en-it": "EMEA", // Italia (inglese)
  "/it-it": "EMEA", // Italia (italiano)
  "/en-es": "EMEA", // Spagna (inglese)
  "/es-es": "EMEA", // Spagna (spagnolo)
  "/en-nl": "EMEA", // Paesi Bassi
  "/en-be": "EMEA", // Belgio
  "/en-at": "EMEA", // Austria
  "/en-ie": "EMEA", // Irlanda
  "/en-se": "EMEA", // Svezia
  "/en-dk": "EMEA", // Danimarca
  "/en-fi": "EMEA", // Finlandia
  "/en-pt": "EMEA", // Portogallo
  "/en-gr": "EMEA", // Grecia
  "/en-pl": "EMEA", // Polonia
  "/en-cz": "EMEA", // Repubblica Ceca
  "/en-ro": "EMEA", // Romania
  "/en-hu": "EMEA", // Ungheria
  "/en-no": "EMEA", // Norvegia
  "/en-ch": "EMEA", // Svizzera
  "/en-sk": "EMEA", // Slovacchia
  "/en-si": "EMEA", // Slovenia
  "/en-bg": "EMEA", // Bulgaria
  "/en-hr": "EMEA", // Croazia
  "/en-cy": "EMEA", // Cipro
  "/en-ee": "EMEA", // Estonia
  "/en-lv": "EMEA", // Lettonia
  "/en-lt": "EMEA", // Lituania
  "/en-lu": "EMEA", // Lussemburgo
  "/en-mt": "EMEA", // Malta

  // AU suffixes
  "/en-au": "AU"
};

/**
 * Determina la regione in base al suffisso URL e alle informazioni di localizzazione
 * @param {Object} localeInfo - Informazioni sulla locale corrente
 * @returns {String} - La regione determinata (US, CA, EMEA, AU, DEFAULT)
 */
function determineRegion(localeInfo) {
  // Estrai il rootUrl e il codice ISO dalla locale
  const rootUrl = localeInfo.current.root_url;
  const isoCode = localeInfo.current.iso_code;
  
  // Verifica nella mappatura
  if (window.PERSOL_ROOT_URL_MAPPINGS[rootUrl]) {
    return window.PERSOL_ROOT_URL_MAPPINGS[rootUrl];
  }
  
  // Fallback: prova ad estrarre il paese dal codice ISO
  const country = (isoCode.split('-')[1] || "").toUpperCase();
  
  if (country === "US") {
    return "US";
  } else if (country === "CA") {
    return "CA";
  } else if (country === "AU") {
    return "AU";
  } else if (["IT", "DE", "FR", "ES", "GB", "EU", "AT", "BE", "BG", 
              "HR", "CY", "CZ", "DK", "EE", "FI", "GR", "HU", "IE", 
              "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", 
              "SI", "SE", "NO", "CH"].indexOf(country) >= 0) {
    return "EMEA";
  } else {
    return "DEFAULT";
  }
}

/**
 * Funzione globale per rilevare la regione in base alle localizzazioni di Shopify
 * @returns {String} - La regione determinata (US, CA, EMEA, AU, DEFAULT)
 */
window.detectRegionFromShopifyLocales = function() {
  // Se abbiamo già memorizzato la regione, restituiscila
  if (window.PERSOL_STORE_REGION) {
    return window.PERSOL_STORE_REGION;
  }
  
  // Altrimenti determina la regione
  if (window.SHOP_LOCALES) {
    return determineRegion(window.SHOP_LOCALES);
  }
  
  // Default se non possiamo determinare la regione
  console.error("Impossibile determinare la regione (SHOP_LOCALES non disponibile)");
  return "DEFAULT";
};

// Inizializza la regione quando lo script viene caricato
document.addEventListener('DOMContentLoaded', function() {
  // La variabile SHOP_LOCALES deve essere già stata definita in theme.liquid
  if (window.SHOP_LOCALES) {
    window.PERSOL_STORE_REGION = determineRegion(window.SHOP_LOCALES);
    //console.log("Current locale:", window.SHOP_LOCALES.current);
    //console.log("All locales:", window.SHOP_LOCALES.all);
    //console.log("Detected region:", window.PERSOL_STORE_REGION);
  } else {
    console.error("SHOP_LOCALES non definito. Verificare l'inclusione dello script in theme.liquid");
  }
});
